import { InputWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'
import { useEffect } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { RoomType } from '../../types/roomtype'

interface RoomtypeInventoryAndBookingDetailsProps {
  values: RoomType
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<RoomType>
  touched: FormikTouched<RoomType>
  handleBlur: any
  isSubmitting: any
  classes: any
}

export const RoomtypeInventoryAndBookingDetails: React.FC<
  RoomtypeInventoryAndBookingDetailsProps
> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  classes
}) => {
  useEffect(() => {
    if (values.basicDetails.type === 'Virtual') {
      setFieldValue('inventoryAndBooking.defaultOccupancy', 0)
      setFieldValue('inventoryAndBooking.maxOccupancy', 0)
    }
  }, [values.basicDetails.type])

  return (
    <>
      <SectionTitle title="Inventory & Booking" marginBottom />
      <div className={classes.fieldsContainer}>
        <InputWithLabel
          label={getTranslate('Number Of Rooms')}
          placeholder={getTranslate('example: ') + 15}
          autoComplete="off"
          name="inventoryAndBooking.numberOfRooms"
          id="inventoryAndBooking.numberOfRooms"
          value={values.inventoryAndBooking.numberOfRooms}
          onChange={(event) =>
            setFieldValue(
              'inventoryAndBooking.numberOfRooms',
              typeof parseInt(event.currentTarget.value, 10) === 'number' &&
                !isNaN(parseInt(event.currentTarget.value, 10))
                ? parseInt(event.currentTarget.value, 10)
                : parseInt('0')
            )
          }
          error={
            (touched.inventoryAndBooking?.numberOfRooms &&
              !!errors.inventoryAndBooking?.numberOfRooms) ||
            undefined
          }
          helpertext={
            touched.inventoryAndBooking?.numberOfRooms
              ? getTranslate(errors.inventoryAndBooking?.numberOfRooms || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          label={getTranslate('Default Occupancy')}
          placeholder={getTranslate('example: ') + 15}
          autoComplete="off"
          name="inventoryAndBooking.defaultOccupancy"
          id="inventoryAndBooking.defaultOccupancy"
          value={values.inventoryAndBooking.defaultOccupancy}
          onChange={(event) => {
            setFieldValue(
              'inventoryAndBooking.defaultOccupancy',
              typeof parseInt(event.currentTarget.value, 10) === 'number' &&
                !isNaN(parseInt(event.currentTarget.value, 10))
                ? parseInt(event.currentTarget.value, 10)
                : parseInt('0')
            )
          }}
          error={
            (touched.inventoryAndBooking?.defaultOccupancy &&
              !!errors.inventoryAndBooking?.defaultOccupancy) ||
            undefined
          }
          helpertext={
            touched.inventoryAndBooking?.defaultOccupancy
              ? getTranslate(errors.inventoryAndBooking?.defaultOccupancy || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          label={getTranslate('Max Occupancy')}
          placeholder={getTranslate('example: ') + 15}
          autoComplete="off"
          name="inventoryAndBooking.maxOccupancy"
          id="inventoryAndBooking.maxOccupancy"
          value={values.inventoryAndBooking.maxOccupancy}
          onChange={(event) => {
            setFieldValue(
              'inventoryAndBooking.maxOccupancy',
              typeof parseInt(event.currentTarget.value, 10) === 'number' &&
                !isNaN(parseInt(event.currentTarget.value, 10))
                ? parseInt(event.currentTarget.value, 10)
                : parseInt('0')
            )
          }}
          error={
            (touched.inventoryAndBooking?.maxOccupancy &&
              !!errors.inventoryAndBooking?.maxOccupancy) ||
            undefined
          }
          helpertext={
            touched.inventoryAndBooking?.maxOccupancy
              ? getTranslate(errors.inventoryAndBooking?.maxOccupancy || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
      </div>
    </>
  )
}
